"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyEventTrigger = exports.RecommenderType = exports.ExportType = exports.SurveyStatus = exports.SurveyQuestionType = exports.SmsSources = exports.EmailSources = exports.DefaultSorting = exports.CartItemSource = exports.BulkActionType = exports.IndianStates = exports.Country = exports.Currency = exports.PaymentStatus = exports.PaymentType = exports.CouponType = exports.ProductStatus = exports.StatusDelivery = exports.OrderProductStatus = exports.OrderStatus = exports.CouponPaymentMethod = exports.Domains = exports.ShippingTierType = exports.PaymentMethod = exports.CategorySorting = void 0;
var CategorySorting;
(function (CategorySorting) {
    CategorySorting["RECOMMENDED"] = "default";
    CategorySorting["LATEST"] = "latest";
    CategorySorting["BEST_SELLERS"] = "best-seller";
    CategorySorting["HIGHEST_RATED"] = "popularity";
    CategorySorting["PRICE_HIGH_TO_LOW"] = "price-high";
    CategorySorting["PRICE_LOW_TO_HIGH"] = "price-low";
})(CategorySorting || (exports.CategorySorting = CategorySorting = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["COD"] = "COD";
    PaymentMethod["ONLINE"] = "ONLINE";
    PaymentMethod["CASHBACK"] = "CASHBACK";
})(PaymentMethod || (exports.PaymentMethod = PaymentMethod = {}));
var ShippingTierType;
(function (ShippingTierType) {
    ShippingTierType["CUSTOM"] = "CUSTOM";
    ShippingTierType["COUPON"] = "COUPON";
})(ShippingTierType || (exports.ShippingTierType = ShippingTierType = {}));
var Domains;
(function (Domains) {
    Domains["NATURE_DERMA"] = "NATURE_DERMA";
    Domains["BODY_CUPID"] = "BODY_CUPID";
})(Domains || (exports.Domains = Domains = {}));
var CouponPaymentMethod;
(function (CouponPaymentMethod) {
    CouponPaymentMethod["ALL"] = "ALL";
    CouponPaymentMethod["COD"] = "COD";
    CouponPaymentMethod["ONLINE"] = "ONLINE";
})(CouponPaymentMethod || (exports.CouponPaymentMethod = CouponPaymentMethod = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["PENDING"] = "PENDING";
    OrderStatus["CONFIRMED"] = "CONFIRMED";
    OrderStatus["COMPLETE"] = "COMPLETE";
    OrderStatus["DISPATCHED"] = "DISPATCHED";
    OrderStatus["DELIVERED"] = "DELIVERED";
    OrderStatus["CANCELLED"] = "CANCELLED";
    OrderStatus["RETURNED"] = "RETURNED";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
var OrderProductStatus;
(function (OrderProductStatus) {
    OrderProductStatus["CREATED"] = "CREATED";
    OrderProductStatus["CANCELLED"] = "CANCELLED";
    OrderProductStatus["DISPATCHED"] = "DISPATCHED";
    OrderProductStatus["DELIVERED"] = "DELIVERED";
    OrderProductStatus["RETURN_REQUESTED"] = "RETURN_REQUESTED";
    OrderProductStatus["COURIER_RETURN"] = "COURIER_RETURN";
})(OrderProductStatus || (exports.OrderProductStatus = OrderProductStatus = {}));
var StatusDelivery;
(function (StatusDelivery) {
    StatusDelivery["DRAFT"] = "DRAFT";
    StatusDelivery["PENDING"] = "PENDING";
    StatusDelivery["CONFIRMED"] = "CONFIRMED";
    StatusDelivery["SHIPPED"] = "SHIPPED";
    StatusDelivery["DELIVERED"] = "DELIVERED";
    StatusDelivery["CANCELLED"] = "CANCELLED";
})(StatusDelivery || (exports.StatusDelivery = StatusDelivery = {}));
var ProductStatus;
(function (ProductStatus) {
    ProductStatus["ENABLED"] = "ENABLED";
    ProductStatus["DISABLED"] = "DISABLED";
})(ProductStatus || (exports.ProductStatus = ProductStatus = {}));
var CouponType;
(function (CouponType) {
    CouponType["PERCENTAGE"] = "PERCENTAGE";
    CouponType["FIXED"] = "FIXED";
    CouponType["BUY_X_GET_Y"] = "BUY_X_GET_Y";
    CouponType["BUY_X_AT_Y"] = "BUY_X_AT_Y";
    CouponType["PRODUCT"] = "PRODUCT";
    CouponType["FREEBIE"] = "FREEBIE";
})(CouponType || (exports.CouponType = CouponType = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["COD"] = "COD";
    PaymentType["PREPAID"] = "PREPAID";
    PaymentType["PPCOD"] = "PPCOD";
    PaymentType["ALL"] = "ALL";
})(PaymentType || (exports.PaymentType = PaymentType = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["UNPAID"] = "UNPAID";
    PaymentStatus["PAID"] = "PAID";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var Currency;
(function (Currency) {
    Currency["INR"] = "INR";
})(Currency || (exports.Currency = Currency = {}));
var Country;
(function (Country) {
    Country["IN"] = "IN";
})(Country || (exports.Country = Country = {}));
var IndianStates;
(function (IndianStates) {
    IndianStates["AN"] = "AN";
    IndianStates["AP"] = "AP";
    IndianStates["AR"] = "AR";
    IndianStates["AS"] = "AS";
    IndianStates["BR"] = "BR";
    IndianStates["CH"] = "CH";
    IndianStates["CG"] = "CG";
    IndianStates["DN"] = "DN";
    IndianStates["DD"] = "DD";
    IndianStates["DL"] = "DL";
    IndianStates["GA"] = "GA";
    IndianStates["GJ"] = "GJ";
    IndianStates["HR"] = "HR";
    IndianStates["HP"] = "HP";
    IndianStates["JK"] = "JK";
    IndianStates["JH"] = "JH";
    IndianStates["KA"] = "KA";
    IndianStates["KL"] = "KL";
    IndianStates["LA"] = "LA";
    IndianStates["LD"] = "LD";
    IndianStates["MP"] = "MP";
    IndianStates["MH"] = "MH";
    IndianStates["MN"] = "MN";
    IndianStates["ML"] = "ML";
    IndianStates["MZ"] = "MZ";
    IndianStates["NL"] = "NL";
    IndianStates["OR"] = "OR";
    IndianStates["PY"] = "PY";
    IndianStates["PB"] = "PB";
    IndianStates["RJ"] = "RJ";
    IndianStates["SK"] = "SK";
    IndianStates["TN"] = "TN";
    IndianStates["TS"] = "TS";
    IndianStates["TR"] = "TR";
    IndianStates["UP"] = "UP";
    IndianStates["UK"] = "UK";
    IndianStates["WB"] = "WB";
})(IndianStates || (exports.IndianStates = IndianStates = {}));
var BulkActionType;
(function (BulkActionType) {
    BulkActionType["SHOPIFY_PRODUCTS"] = "SHOPIFY_PRODUCTS";
    BulkActionType["PRODUCTS"] = "PRODUCTS";
    BulkActionType["REVIEWS"] = "REVIEWS";
})(BulkActionType || (exports.BulkActionType = BulkActionType = {}));
var CartItemSource;
(function (CartItemSource) {
    CartItemSource["LIMITED_TIME_DEAL"] = "LIMITED_TIME_DEAL";
    CartItemSource["COUPON"] = "COUPON";
})(CartItemSource || (exports.CartItemSource = CartItemSource = {}));
var DefaultSorting;
(function (DefaultSorting) {
    DefaultSorting["RECOMMENDED"] = "RECOMMENDED";
    DefaultSorting["LATEST"] = "LATEST";
    DefaultSorting["BEST_SELLERS"] = "BEST_SELLERS";
    DefaultSorting["HIGHEST_RATED"] = "HIGHEST_RATED";
    DefaultSorting["PRICE_HIGH_TO_LOW"] = "PRICE_HIGH_TO_LOW";
    DefaultSorting["PRICE_LOW_TO_HIGH"] = "PRICE_LOW_TO_HIGH";
})(DefaultSorting || (exports.DefaultSorting = DefaultSorting = {}));
var EmailSources;
(function (EmailSources) {
    EmailSources["PINPOINT"] = "PINPOINT";
})(EmailSources || (exports.EmailSources = EmailSources = {}));
var SmsSources;
(function (SmsSources) {
    SmsSources["GUPSHUP"] = "GUPSHUP";
})(SmsSources || (exports.SmsSources = SmsSources = {}));
var SurveyQuestionType;
(function (SurveyQuestionType) {
    SurveyQuestionType["CHECKBOX"] = "CHECKBOX";
    SurveyQuestionType["RADIO"] = "RADIO";
    SurveyQuestionType["TEXT"] = "TEXT";
})(SurveyQuestionType || (exports.SurveyQuestionType = SurveyQuestionType = {}));
var SurveyStatus;
(function (SurveyStatus) {
    SurveyStatus["DRAFT"] = "DRAFT";
    SurveyStatus["OPEN"] = "OPEN";
    SurveyStatus["CLOSE"] = "CLOSE";
})(SurveyStatus || (exports.SurveyStatus = SurveyStatus = {}));
var ExportType;
(function (ExportType) {
    ExportType["ALL"] = "ALL";
    ExportType["SELECTED"] = "SELECTED";
})(ExportType || (exports.ExportType = ExportType = {}));
var RecommenderType;
(function (RecommenderType) {
    RecommenderType["BEST_SELLER"] = "BEST_SELLER";
    RecommenderType["FREQUENTLY_BOUGHT_TOGETHER"] = "FREQUENTLY_BOUGHT_TOGETHER";
})(RecommenderType || (exports.RecommenderType = RecommenderType = {}));
var LoyaltyEventTrigger;
(function (LoyaltyEventTrigger) {
    LoyaltyEventTrigger["CREDIT_PREPAID_ORDER"] = "CREDIT_PREPAID_ORDER";
    LoyaltyEventTrigger["CREDIT_COD_ORDER"] = "CREDIT_COD_ORDER";
    LoyaltyEventTrigger["CREDIT_USER_SIGNUP"] = "CREDIT_USER_SIGNUP";
    LoyaltyEventTrigger["CREDIT_COUPON"] = "CREDIT_COUPON";
    LoyaltyEventTrigger["CREDIT_USER_CONSTRAINS"] = "CREDIT_USER_CONSTRAINS";
    LoyaltyEventTrigger["DEBIT_PREPAID_ORDER"] = "DEBIT_PREPAID_ORDER";
    LoyaltyEventTrigger["DEBIT_COD_ORDER"] = "DEBIT_COD_ORDER";
    LoyaltyEventTrigger["DEBIT_ORDER_CANCELLED"] = "DEBIT_ORDER_CANCELLED";
    LoyaltyEventTrigger["DEBIT_EXPIRED"] = "DEBIT_EXPIRED";
    LoyaltyEventTrigger["DEBIT_USER_CONSTRAINS"] = "DEBIT_USER_CONSTRAINS";
    LoyaltyEventTrigger["CREDIT_PPCOD_ORDER"] = "CREDIT_PPCOD_ORDER";
    LoyaltyEventTrigger["DEBIT_PPCOD_ORDER"] = "DEBIT_PPCOD_ORDER";
})(LoyaltyEventTrigger || (exports.LoyaltyEventTrigger = LoyaltyEventTrigger = {}));
var RuleType;
(function (RuleType) {
    RuleType["DEBIT"] = "DEBIT";
    RuleType["CREDIT"] = "CREDIT";
})(RuleType || (RuleType = {}));
var Operator;
(function (Operator) {
    Operator["eq"] = "eq";
    Operator["gte"] = "gte";
    Operator["lte"] = "lte";
    Operator["gt"] = "gt";
    Operator["lt"] = "lt";
    Operator["ne"] = "ne";
})(Operator || (Operator = {}));
